import React, { useId } from "react";

import UploadPhotoIcon from "assets/icons/UploadPhotoIcon";

interface FileInputProps {
  label: string;
  buttonLabel: string;
  multipleSelect?: boolean;
  acceptType?: string;
  onUpload: (files: FileList | null) => void;
}

const FileInput: React.FC<FileInputProps> = ({
  label,
  buttonLabel,
  multipleSelect = false,
  acceptType = "",
  onUpload,
}) => {
  const inputId = useId();

  return (
    <div className="w-full bg-[#F4F4F4] px-3 py-2 flex flex-row justify-between items-center space-x-2 rounded-md transition-colors duration-200 ease-out hover:bg-[#EFEFEF]">
      <div className="p-1 border-2 border-[#A0A0A0] border-dashed rounded-lg transition-colors duration-200 ease-out hover:border-primary">
        <UploadPhotoIcon width={32} height={32} color={"#767676"} />
      </div>
      <p className="flex-1 text-sm lg:text-base">{label}</p>
      <label htmlFor={inputId} className="cursor-pointer">
        <div
          className="flex items-center gap-2 rounded-md border border-primary bg-white p-2 text-base text-primary transition-colors duration-200 ease-out hover:bg-primary/10"
        >
          <UploadPhotoIcon width={18} height={18} color={"#00A09B"} />
          {buttonLabel}
        </div>
        <input
          type="file"
          multiple={multipleSelect}
          accept={acceptType}
          id={inputId}
          style={{ display: "none" }}
          onChange={(e) => onUpload(e.target.files)}
          onClick={(e: any) => (e.target.value = null)}
        ></input>
      </label>
    </div>
  );
};

export default FileInput;
